/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 12:25:44
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 17:12:33
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/content/index.ts
 */

import {
  IAllProductPage,
  IContentProfilePage,
  IContentSearchPage,
  IContentSearchPageFromServer,
  IContentShoppingCart,
  IContentShoppingCartFromServer,
  IPromotion,
} from '@/src/types/common/SalesChannel';
import { networkSuccessCb as _successCb } from 'src/tools/helper';
import { get, post, remove } from 'src/tools/server';
import { EnumSiderEvent } from 'src/types/common/sider';

const successCb = () => {
  _successCb(EnumSiderEvent.salesChannelContent);
};

const getContentHomepage = (contentUuid, params): Promise<any> => {
  return get<any>(`/portal/contentHomePage/${contentUuid}`, params);
};

const postContentHomepage = (body, params): Promise<any> => {
  return post<any>(`/portal/contentHomePage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const postContentHomepage_new = (body, params): Promise<any> => {
  return post<any>(`/portal/contentHomePage/responsive`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const postContentContentPage_new = (body, params): Promise<any> => {
  return post<any>(`/portal/contentPage/responsive`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContentHomepage_new = (contentUuid, params): Promise<any> => {
  return get<any>(`/portal/contentHomePage/responsive/${contentUuid}`, params);
};

const getContentContentPage_new = (contentUuid, params): Promise<any> => {
  return get<any>(`/portal/contentPage/responsive/${contentUuid}`, params);
};

const getContentTabBar = (contentId, params): Promise<any> => {
  return get<any>(`/portal/contentTabBarPage/${contentId}`, params || {});
};

const postContentTabBar = (body, contentUuid, params): Promise<any> => {
  return post<any>(`/portal/contentTabBars/${contentUuid}`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContent404Page = (contentUuid, params): Promise<any> => {
  return get<any>(`/portal/content404Page/${contentUuid}`, params);
};

const getContent404Page_revamp = (contentUuid, params): Promise<any> => {
  return get<any>(`/portal/content404Page/3In1/${contentUuid}`, params);
};

const postContent404Page = (body, params): Promise<any> => {
  return post<any>(`/portal/content404Page`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const postContent404Page_revamp = (body, params): Promise<any> => {
  return post<any>(`/portal/content404Page/3In1`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContentProductSearch = (
  contentUuid,
  params,
): Promise<IContentSearchPageFromServer> => {
  return get<IContentSearchPageFromServer>(
    `/portal/contentSearchPage/${contentUuid}`,
    params,
  );
};

const postContentProductSearch = (
  body,
  params,
): Promise<IContentSearchPage> => {
  return post<IContentSearchPage>(`/portal/contentSearchPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContentPromotion = (contentUuid, params): Promise<IPromotion> => {
  return get<IPromotion>(`/portal/contentPromotionPage/${contentUuid}`, params);
};

const postContentPromotion = (body, params): Promise<any> => {
  return post<any>(`/portal/contentPromotionPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContentShoppingCart = (
  contentUuid,
  params,
): Promise<IContentShoppingCartFromServer> => {
  return get<IContentShoppingCartFromServer>(
    `/portal/contentShoppingCartPage/${contentUuid}`,
    {
      afterSuccessCb: () => {
        console.log(1);
      },
      ...params,
    },
  );
};

const getContentShoppingCartResetConfig = (
  uuid,
  params,
): Promise<IContentShoppingCartFromServer> => {
  return get<IContentShoppingCartFromServer>(
    `/portal/contentShoppingCartPage/reset/${uuid}`,
    params || {},
  );
};

const postContentShoppingCart = (
  body,
  params,
): Promise<IContentShoppingCart> => {
  return post<IContentShoppingCart>(`/portal/contentShoppingCartPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getContentMaintenance = (uuid: string, params) => {
  return get<any>(`/portal/contentMaintenancePage/${uuid}`, params);
};

const postContentMaintenance = (body, params): Promise<any> => {
  return post<any>(`/portal/contentMaintenancePage`, body, {
    ...params,
    //   afterSuccessCb: successCb,
  });
};

const getContentProfilePage = (
  contentUuid,
  params,
): Promise<IContentProfilePage> => {
  return get<IContentProfilePage>(
    `/portal/contentProfilePage/${contentUuid}`,

    params || {},
  );
};

const getContentProfilePage_revamp = (contentUuid, params): Promise<any> => {
  return get(`/portal/contentProfilePage/3In1/${contentUuid}`, params);
};

const postContentProfilePage = (body, params): Promise<IContentProfilePage> => {
  return post<IContentProfilePage>(`/portal/contentProfilePage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const postContentProfilePage_revamp = (body, params): Promise<any> => {
  return post(`/portal/contentProfilePage/3In1`, body, params);
};

const getContentContentPage = (uuid: string, params) => {
  return get<any>(`/portal/contentPage/${uuid}`, params || {});
};

const getContentContentPages = (uuid: string, params?) => {
  return get<any>(`/portal/contentPages/${uuid}`, params || {});
};

const deleteContentContentPage = (uuid: string) => {
  return remove<any>(`/portal/contentPage/${uuid}`, {
    afterSuccessCb: successCb,
  });
};

const duplicateContentContentPage = (uuid: string, params) => {
  return post<any>(
    `/portal/contentPage/duplicate/${uuid}`,
    {},
    { afterSuccessCb: successCb, ...(params || {}) },
  );
};

const postContentContentPage = (body, params): Promise<any> => {
  return post<any>(`/portal/contentPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getInitialContentContentPage = (uuid: string, params): Promise<any> => {
  return get<any>(`/portal/contentPage/initialise/${uuid}`, params);
};

const getInitialFloatingBar = (): Promise<any> => {
  return get<any>(`/portal/defaultFloatingBar`, {});
};

const postAllProductsPage = (body, params): Promise<IAllProductPage> => {
  return post<IAllProductPage>(`/portal/contentAllProductsPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getAllProductsPage = (uuid: string, params): Promise<IAllProductPage> => {
  return get<IAllProductPage>(`/portal/contentAllProductsPage/${uuid}`, params);
};

const getAllProductsPage_revamp = (uuid: string, params): Promise<any> => {
  return get<any>(`/portal/contentAllProductsPage/3In1/${uuid}`, params);
};

const postAllProductsPage_revamp = (body, params): Promise<any> => {
  return post<any>(`/portal/contentAllProductsPage/3In1`, body, params);
};

const postAppearance = (body, params): Promise<any> => {
  return post<any>(`/portal/contentAppearancePage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getAppearance = (uuid: string, params): Promise<any> => {
  return get<any>(`/portal/contentAppearancePage/${uuid}`, params || {});
};

const getAppearance_revamp = (uuid: string, params): Promise<any> => {
  return get<any>(`/portal/contentAppearancePage/3In1/${uuid}`, params || {});
};

const postAppearance_revamp = (body, params): Promise<any> => {
  return post<any>(`/portal/contentAppearancePage/3In1`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getSalesChannelContentNavigation = (uuid: string, params: any) => {
  return get<any>(`/portal/${uuid}/navigationPage`, params);
};

const postSalesChannelContentNavigation = (
  uuid: string,
  body: any,
  params: any,
) => {
  return post<any>(`/portal/${uuid}/navigationPage`, body, params);
};

const getSalesChannelContentHeader = (uuid: string, params: any) => {
  return get<any>(`/portal/${uuid}/responsiveHeader`, params);
};

const postSalesChannelContentHeader = (
  uuid: string,
  body: any,
  params: any,
) => {
  return post(`/portal/${uuid}/responsiveHeader`, body, params);
};

const getFooterRequiredInfo = (uuid) => {
  return get<any>(`/portal/contentFooterPage/${uuid}/metaInfo`, {});
};

const getFooter = (uuid, params) => {
  return get<any>(`/portal/contentFooterPage/${uuid}`, params || {});
};

const postFooter = (body, params) => {
  return post<any>(`/portal/contentFooterPage`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getMegaMenu = (uuid, params) => {
  return get<any>(`/portal/contentMegaMenu/${uuid}`, params || {});
};

const postMegaMenu = (body, params) => {
  return post<any>(`/portal/contentMegaMenu`, body, {
    ...params,
    afterSuccessCb: successCb,
  });
};

const getSalesChannelContentAnimation = (uuid: string) => {
  return get<any>(`/portal/contentAnimation/${uuid}/list`, {});
};

const postSalesChannelContentAnimation = (body: any) => {
  return post<any>(`/portal/contentAnimation`, body, {});
};

const getSalesChannelContentText = (uuid: string, params: any) => {
  return get<any>(`/portal/contentText/${uuid}`, params);
};

const postSalesChannelContentText = (body: any, params: any) => {
  return post<any>(`/portal/contentText`, body, params);
};

const getMegaMenuMetaInfo = (uuid, params) => {
  return get<any>(`/portal/contentMegaMenu/${uuid}/metaInfo`, params || {});
};

const getSalesChannelContentButton = (uuid, params) => {
  return get<any>(`/portal/contentButton/${uuid}`, params);
};

const getContentButtonThemes = (uuid, params?) => {
  return get<any>(`/portal/contentButton/${uuid}/themes`, params);
};

const postSalesChannelContentButton = (body, params) => {
  return post<any>(`/portal/contentButton`, body, params);
};

const getContentLayerMetaInfo = (contentUuid) => {
  return get<any>(`/portal/contentLayer/${contentUuid}/metaInfo`, {});
};

const getContentPagesForSisterSc = (body, params) => {
  return post<any>(`/portal/contentPageQuery`, body, params);
};

const postHomePagePreview = (body, params) => {
  return post<any>(`/portal/preview/homePage`, body, params);
};

const postContentPagePreview = (body, params) => {
  return post<any>(`/portal/preview/contentPage`, body, params);
};

// translation
const postTranslateContentHomePage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/contentHomePage/responsive/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateContentHomePage_MP = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/contentHomePage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateContentPage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentPage/responsive/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateContentPag_MP = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentPage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateProductSearch = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/contentSearchPage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateShoppingCartPage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/contentShoppingCartPage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslatePromotionPage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/contentPromotionPage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateAllProductsPage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentAllProductsPage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateTabBar = (
  uuid: string | null,
  contentUuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentTabBars/${contentUuid}/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateProfilePage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentProfilePage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const postTranslateMaintenancePage = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/contentMaintenancePage/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

export {
  getAppearance_revamp,
  postAppearance_revamp,
  postAppearance,
  getAppearance,
  postAllProductsPage,
  getAllProductsPage,
  getContent404Page_revamp,
  postContent404Page_revamp,
  getAllProductsPage_revamp,
  postAllProductsPage_revamp,
  duplicateContentContentPage,
  getContentContentPages,
  deleteContentContentPage,
  getContentContentPage,
  postContentContentPage,
  postContentHomepage,
  postContentHomepage_new,
  getContentHomepage,
  getContentHomepage_new,
  getContentProductSearch,
  postContentProductSearch,
  getContentPromotion,
  postContentPromotion,
  getContentTabBar,
  postContentTabBar,
  getContentShoppingCart,
  postContentShoppingCart,
  postContentPagePreview,
  getContentShoppingCartResetConfig,
  getContent404Page,
  postContent404Page,
  getContentMaintenance,
  postContentMaintenance,
  getContentProfilePage,
  postContentProfilePage,
  getContentProfilePage_revamp,
  postContentProfilePage_revamp,
  getInitialContentContentPage,
  getInitialFloatingBar,
  getSalesChannelContentNavigation,
  postSalesChannelContentNavigation,
  getSalesChannelContentHeader,
  postSalesChannelContentHeader,
  getSalesChannelContentAnimation,
  postSalesChannelContentAnimation,
  getSalesChannelContentText,
  postSalesChannelContentText,
  getSalesChannelContentButton,
  postSalesChannelContentButton,
  getContentButtonThemes,
  getFooterRequiredInfo,
  getFooter,
  postFooter,
  getMegaMenu,
  postMegaMenu,
  getMegaMenuMetaInfo,
  getContentLayerMetaInfo,
  getContentContentPage_new,
  postContentContentPage_new,
  postHomePagePreview,
  getContentPagesForSisterSc,
  postTranslateContentHomePage,
  postTranslateContentHomePage_MP,
  postTranslateContentPage,
  postTranslateContentPag_MP,
  postTranslateProductSearch,
  postTranslateShoppingCartPage,
  postTranslatePromotionPage,
  postTranslateAllProductsPage,
  postTranslateTabBar,
  postTranslateProfilePage,
  postTranslateMaintenancePage,
};
